import styled from 'styled-components';

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-l);

  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  /* On smaller / mobile widths show two columns (2x2 rows when enough items) */
  @media screen and (max-width: 680px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-m);
  }

  /* Very small narrow screens fall back to one column */
  @media screen and (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export const ProductCard = styled.article`
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusLarge);
  background: var(--white);
  box-shadow:
    0 12px 34px rgba(23, 23, 23, 0.04),
    0 2px 7px rgba(23, 23, 23, 0.02);
  transition:
    border-color 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
  &:hover {
    border-color: rgba(230, 139, 7, 0.25);

    box-shadow:
      0 18px 44px rgba(23, 23, 23, 0.075),
      0 3px 10px rgba(23, 23, 23, 0.025);

    transform: translateY(-3px);
  }
`;

export const ProductImageWrap = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3;

  position: relative;

  overflow: hidden;

  border-bottom: 1px solid var(--grey15);

  background: var(--grey0);
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;

  display: block;

  object-fit: contain;

  padding: var(--space-m);

  background: var(--white);
`;

export const ProductImageFallback = styled.div`
  width: 100%;
  height: 100%;

  display: ${({ $hidden }) => ($hidden ? 'none' : 'grid')};
  place-items: center;
  align-content: center;
  gap: var(--space-s);

  color: var(--grey3);

  font-size: 1.4rem;

  span {
    font-size: 0.78rem;
    font-weight: 600;
  }
`;

export const ProductBadge = styled.span`
  position: absolute;
  top: var(--space-s);
  left: var(--space-s);

  padding: var(--space-xs) var(--space-s);

  border: 1px solid var(--yellow5);
  border-radius: var(--borderRadiusButton);

  background: var(--yellow1);

  color: var(--grey7);

  font-size: 0.65rem;
  line-height: 1;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const ProductContent = styled.div`
  /* height: 100%; */

  display: flex;
  flex-direction: column;

  padding: var(--space-l);
`;

export const ProductMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-s);
`;

export const ProductCategory = styled.span`
  color: var(--orange5);

  font-size: 0.68rem;
  line-height: 1.3;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

export const ProductSku = styled.span`
  color: var(--grey3);

  font-size: 0.66rem;
  line-height: 1.3;
  font-weight: 600;

  text-align: right;
`;

export const ProductTitle = styled.h3`
  margin: var(--space-s) 0 0;

  color: var(--grey7);

  font-size: 1.2rem;
  line-height: 1.25;
  font-weight: 800;

  letter-spacing: -0.02em;
`;

export const ProductBrand = styled.p`
  margin: var(--space-xxs) 0 0;
  color: var(--grey3);

  font-size: 0.76rem;
  line-height: 1.4;
  font-weight: 600;
`;

export const ProductFeatures = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  margin: var(--space-m) 0 0;
  padding: 0;
`;

export const ProductFeature = styled.li`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: flex-start;
  gap: var(--space-xs);

  list-style: none;

  color: var(--grey4);

  font-size: 0.76rem;
  line-height: 1.45;
  font-weight: 500;

  svg {
    margin-top: 0.15rem;

    color: var(--successGreen);

    font-size: 0.75rem;
  }
`;

export const ProductFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  margin-top: auto;
  padding-top: var(--space-m);
`;

export const ProductAvailability = styled.p`
  margin: 0;
  /* text-align: center; */
  span {
    font-size: 0.85rem !important;
    color: var(--grey3);
  }

  line-height: 1.35;
  font-weight: 600;
  /* border: 2px solid red; */
`;

export const ProductInquiryButton = styled.button`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);

  padding: var(--space-s) var(--space-m);

  border: 1px solid var(--grey7);
  border-radius: var(--borderRadiusButton);

  background: var(--grey7);

  color: var(--white);

  font-family: var(--mainFont);
  font-size: 0.78rem;
  line-height: 1;
  font-weight: 800;

  cursor: pointer;

  transition:
    background-color 180ms ease,
    transform 180ms ease;

  svg {
    margin-left: auto;
  }

  &:hover {
    background: var(--grey6);

    transform: translateY(-1px);
  }
`;
